import Swiper from 'swiper';
import 'swiper/css/swiper.min.css'

const thumbsOptions = {
    initialSlide:  0,
    slidesPerView: 4,
    preloadImages: false,
    lazy:          true,
    breakpoints:   {
        1280: {
            slidesPerView: 5,
        }
    },
};

const init = (instance, $section) => {
    instance.$el     = $section;
    instance.$thumbs = $section.querySelector('.article__slider_thumbs');

    instance.$galleryThumbs = new Swiper(instance.$thumbs, thumbsOptions);
    instance.$galleryTop    = new Swiper(instance.$el, {
        thumbs:        {
            swiper: instance.$galleryThumbs
        },
        preloadImages: false,
        lazy:          true
    });
};

export default class ArticleSlider {
    constructor($section) {
        return $section ? init(this, $section) : {};
    }
}
